<template>
  <v-text-field v-bind="$attrs" :hint="$attrs.hint as string || t('common.search.syntax')" :title="$attrs.title as string || t('common.search.syntax')">
    <template v-for="(_, name) in $slots" #[name]="slotProps"><slot :name="name" v-bind="slotProps || {}" /></template>
  </v-text-field>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
defineOptions({ inheritAttrs: false })
const { t } = useI18n()
</script>
